import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { BLOG_APP_ID } from '../../constants/applications';
import {
  NAVIGATE_TO_PROFILE,
  NAVIGATE_TO_CREATE_POST,
  NAVIGATE_TO_MY_DRAFTS,
  NAVIGATE_TO_PROFILE_SETTINGS,
  LOGOUT,
} from '../../constants/widget-avatar-actions';
import { buttonClicked } from '../../actions/button-clicked';
import { PrivateProfileActions } from '../../containers/private-profile-actions';
import { sendButtonClicked } from '../../services/widget-popup';
import { getApplicationConfig } from '../../selectors/communities-context-selectors';
import withTranslate from '../../hoc/with-translate';

const mapStateToProps = state => ({
  blogConfig: getApplicationConfig(state, BLOG_APP_ID),
  navigation: {
    navigateToProfile: () => sendButtonClicked({ type: NAVIGATE_TO_PROFILE }),
    navigateToProfileSettings: () => sendButtonClicked({ type: NAVIGATE_TO_PROFILE_SETTINGS }),
    navigateToCreatePost: () => sendButtonClicked({ type: NAVIGATE_TO_CREATE_POST }),
    navigateToMyDrafts: () => sendButtonClicked({ type: NAVIGATE_TO_MY_DRAFTS }),
  },
});

const mapDispatchToProps = dispatch => ({
  buttonClicked: data => dispatch(buttonClicked({ name: 'action_click', type: 'profile_widget', ...data })),
  navigateToRoot: () => {},
  logoutMember: () => sendButtonClicked({ type: LOGOUT }),
});

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslate,
)(PrivateProfileActions);



// WEBPACK FOOTER //
// ./app/containers/popup-widget-profile-actions/popup-widget-profile-actions.js